<cdk-virtual-scroll-viewport #viewedScroller itemSize="28"  class="list-recent">
  <mat-list class="styled">
    <mat-list-item *cdkVirtualFor="let object of recentViewed"
                   [title]="object.obligorName" (click)="onItemClick(object)"
                    class="recent-menu-item">
      <div class="div-recent">
        <div class="text-ellipsis recent-item-val">
          <span class="link-underscore" >{{object.obligorName}}</span>
        </div>
        <div class="recent-item-date">
          <span>{{object.dateCreated | date : 'MM/dd/yyyy'}}</span>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
  <div class="spinner-item" *ngIf="viewedLoading">
    <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50"></mat-progress-spinner>
  </div>
</cdk-virtual-scroll-viewport>
